import React from 'react';
import { Check, CheckCheck, Play, Pause } from 'lucide-react';
import { useState, useRef } from 'react';

const MessageBubble = ({ message, isOwn }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  const handlePlayVoice = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-4`}>
      <div
        className={`max-w-xs lg:max-w-md px-4 py-2 rounded-2xl ${
          isOwn
            ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-br-none'
            : 'bg-gray-800 text-white rounded-bl-none'
        }`}
      >
        {/* Voice Message */}
        {message.voice_url && (
          <div className="flex items-center gap-3">
            <button
              onClick={handlePlayVoice}
              className="p-2 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all"
            >
              {isPlaying ? (
                <Pause className="w-5 h-5" />
              ) : (
                <Play className="w-5 h-5" />
              )}
            </button>
            <div className="flex-1">
              <div className="h-8 flex items-center">
                <div className="flex gap-1 items-end h-full">
                  {[...Array(20)].map((_, i) => (
                    <div
                      key={i}
                      className="w-1 bg-white bg-opacity-60 rounded-full"
                      style={{ height: `${Math.random() * 100}%` }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
            <audio
              ref={audioRef}
              src={`${process.env.REACT_APP_BACKEND_URL}${message.voice_url}`}
              onEnded={() => setIsPlaying(false)}
            />
          </div>
        )}

        {/* Text Message */}
        {message.content && !message.voice_url && (
          <p className="text-sm whitespace-pre-wrap break-words">
            {message.content}
            {message.emoji && <span className="ml-2 text-2xl">{message.emoji}</span>}
          </p>
        )}

        {/* Timestamp and Read Receipt */}
        <div className={`flex items-center gap-1 mt-1 ${isOwn ? 'justify-end' : 'justify-start'}`}>
          <span className="text-xs opacity-70">{formatTime(message.created_at)}</span>
          {isOwn && (
            <span>
              {message.is_read ? (
                <CheckCheck className="w-4 h-4 text-blue-300" />
              ) : (
                <Check className="w-4 h-4 opacity-70" />
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
